import type { ResolutionConfig } from '@doer/frontend-components/creativity-editor';
import { LAYOUTS_CONFIG } from './config';

/**
 * Resolutions for the standalone editor (no form / bindings).
 *
 * Each entry pairs a layout from LAYOUTS_CONFIG with explicit canvas dimensions.
 * Canvas dims live here (not derived from the layout JSON) because CanvasJSON
 * has no top-level width/height — they're a property of the resolution, not the JSON.
 *
 * Default is Full HD vertical (1080×1920); the on-screen canvas still fits to its
 * container via useCanvasFit, these are the *design* dimensions for export.
 */
type StandaloneResolutionInput = {
  id: string;
  label: string;
  canvasWidth: number;
  canvasHeight: number;
  layoutId: keyof typeof LAYOUTS_CONFIG;
};

const RESOLUTIONS: StandaloneResolutionInput[] = [
  { id: 'macro0001', label: '9:16 — Macro 1', canvasWidth: 1080, canvasHeight: 1920, layoutId: 'macro0001' }
];

export const STANDALONE_RESOLUTIONS: ResolutionConfig[] = RESOLUTIONS.map(r => ({
  id: r.id,
  label: r.label,
  canvasWidth: r.canvasWidth,
  canvasHeight: r.canvasHeight,
  type: 'video',
  layout: LAYOUTS_CONFIG[r.layoutId].canvas
}));
